// extracted by mini-css-extract-plugin
export default {"collapse":"ContractResponsiblesCollapse_collapse__DxkKv","icon":"ContractResponsiblesCollapse_icon__lvxqg"};